import { FC, useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { Card } from './components/Card';
import {
  HavePromocodeSection,
  IHavePromocodeSectionProps,
} from './components/HavePromocodeSection';
import { NotFoundPromotions } from './components/NotFoundPromotions';
import GeneralSkeleton from '@/components/skeletons/GeneralSkeleton';
import { AppParameter, setAppCookie } from '@/helpers/conf';
import { groupMembeRakeback } from '@/helpers/user';
import { useCookie } from '@/hooks/common';
import { useCMSCasinoBonuses } from '@/modules/bonuses';
import { useCommonStore } from '@/store';

import { ScAllOffers, ScCardRow } from './styled';

export const AllOffers: FC<IHavePromocodeSectionProps> = (props) => {
  const { bonuses: selectedBonuses, isLoading } = useCMSCasinoBonuses();

  const { user, pendingUser, fetchRakebacks } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      pendingUser: state.pendingUser,
      fetchRakebacks: state.fetchRakebacks,
    }))
  );

  useCookie(setAppCookie({ name: AppParameter.PromoPage }));

  useEffect(() => {
    const userWithRakeback = groupMembeRakeback(user);

    userWithRakeback && fetchRakebacks();
  }, [fetchRakebacks, user]);

  return (
    <ScAllOffers>
      {pendingUser || isLoading ? (
        <GeneralSkeleton />
      ) : !selectedBonuses.length ? (
        <NotFoundPromotions />
      ) : (
        <ScCardRow>
          {selectedBonuses.map((bonus) => (
            <Card key={bonus.id} {...bonus} />
          ))}
        </ScCardRow>
      )}
      {user && <HavePromocodeSection {...props} />}
    </ScAllOffers>
  );
};
